import $ from 'jquery';
import ScrollMagic from "ScrollMagic";
import 'debug.addIndicators';
import 'animation.gsap';
import { Power1, Power0, Power4, Linear, TweenMax } from "gsap/TweenMax";



export default () => {

    $('.cta, .collapse').on('mouseenter', function(e) {
        var target = $(this).attr('data-zoom');
        //console.log(target);
        $(target).addClass('zoom-in');
        $(target).parent('.img-zindex').addClass('zoom-in');
    }).on('mouseleave', function(e) {
        var target = $(this).attr('data-zoom');
        //console.log(target);
        $(target).removeClass('zoom-in');
        $(target).parent('.img-zindex').removeClass('zoom-in');
    });

};



// WEBPACK FOOTER //
// ./scripts/libs/zoom-in-image.js